export default __webpack_public_path__ + "static/unselectedIcon-5f2287f4396ed5cfb65511a75b53e3cf.svg";